import ApplicantRepository from "../../ports/applicantRepository";
import { ApplicantDocument } from "../../../entities/applicant";

export type updateApplicantDocumentsUsecase = (
  id: string,
  file: Blob | File, 
  fileName: string,
) => Promise<ApplicantDocument>;

export const buildUpdateApplicantDocuments = (dependencies: {
  applicantRepo: ApplicantRepository;
}): updateApplicantDocumentsUsecase => {
  const { applicantRepo } = dependencies;

  const updateApplicantDocuments:updateApplicantDocumentsUsecase = async (
    id: string,
    file: Blob | File, 
    fileName: string
  ) => applicantRepo.updateApplicantDocuments(id, file, fileName);

  return updateApplicantDocuments;
};
